import {
  EDIT,
  CLEAR_EDIT,
  EDIT_TITLE,
  EDIT_TYPE,
  EDIT_AUDIO,
  EDIT_VOICE,
  EDIT_PICTURE,
  EDIT_VOICE_TYPE,
  EDIT_LANGUAGE,
  EDIT_REVIEWED_WORDS,
  EDIT_REVIEWED_INDIRECTLY,
  EDIT_WORDS,
  EDIT_ANSWER,
  EDIT_WORD,
  EDIT_OPTION,
  EDIT_CORRECT_ANSWER,
  EDIT_ID,
  EDIT_NEW_WORDS,
} from "../action/types";
const initialState = {
  edit: false,
  title: "",
  type: "",
  audio: false,
  voice: "",
  picture: "",
  voice_type: "other", //man , female . other (man or female)
  language: "fa",
  reviewed_words: [],
  reviewed_indirectly: [],
  words: [],
  //
  answer: [], // =>
  word: [],
  option: [],
  correct_answer: [],
  id: "",
  new_words: [],
  //
};

function userReducer(state, action) {
  if (typeof state === "undefined") {
    return initialState;
  }

  switch (action.type) {
    case EDIT: {
      return {
        ...state,
        edit: action.payload,
      };
    }
    case CLEAR_EDIT: {
      return initialState
    }
    case EDIT_TITLE: {
      return {
        ...state,
        title: action.payload,
      };
    }
    case EDIT_TYPE: {
      return {
        ...state,
        type: action.payload,
      };
    }
    case EDIT_AUDIO: {
      return {
        ...state,
        audio: action.payload,
      };
    }
    case EDIT_VOICE: {
      return {
        ...state,
        voice: action.payload,
      };
    }
    case EDIT_PICTURE: {
      return {
        ...state,
        picture: action.payload,
      };
    }
    case EDIT_VOICE_TYPE: {
      return {
        ...state,
        voice_type: action.payload,
      };
    }
    case EDIT_LANGUAGE: {
      return {
        ...state,
        language: action.payload,
      };
    }
    case EDIT_REVIEWED_WORDS: {
      return {
        ...state,
        reviewed_words: action.payload,
      };
    }
    case EDIT_REVIEWED_INDIRECTLY: {
      return {
        ...state,
        reviewed_indirectly: action.payload,
      };
    }
    case EDIT_WORDS: {
      return {
        ...state,
        words: action.payload,
      };
    }
    case EDIT_ANSWER: {
      return {
        ...state,
        answer: action.payload,
      };
    }
    case EDIT_WORD: {
      return {
        ...state,
        word: action.payload,
      };
    }
    case EDIT_OPTION: {
      return {
        ...state,
        option: action.payload,
      };
    }
    case EDIT_CORRECT_ANSWER: {
      return {
        ...state,
        correct_answer: action.payload,
      };
    }
    case EDIT_ID: {
      return {
        ...state,
        id: action.payload,
      };
    }
    case EDIT_NEW_WORDS: {
      return {
        ...state,
        new_words: action.payload,
      };
    }
    default:
      return state;
  }
}

export default userReducer;
